import { render, staticRenderFns } from "./TableNotFound.vue?vue&type=template&id=1a82b5ee&scoped=true&lang=html&"
import script from "./TableNotFound.vue?vue&type=script&lang=js&"
export * from "./TableNotFound.vue?vue&type=script&lang=js&"
import style0 from "./TableNotFound.vue?vue&type=style&index=0&id=1a82b5ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a82b5ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
